import { hasScopedPermission, GrantsType } from '../../Shared/utils/auth';

export const updateStateCompliancePolicy = (
  grants: GrantsType,
  ctx: {
    ancestorIds: Array<string>;
  }
) => {
  if (
    hasScopedPermission(
      grants,
      'system',
      'licensed_agency_authorizations.update'
    )
  ) {
    return true;
  }

  return (
    hasScopedPermission(
      grants,
      'partner',
      'licensed_agency_authorizations.update'
    ) &&
    grants.some((grant) => {
      return (
        grant.scope === 'partner' &&
        grant.scopeId &&
        ctx.ancestorIds.includes(grant.scopeId)
      );
    })
  );
};
